import { createContext } from 'react';
import { PropertiesContextProps } from './Properties.types';

// @ts-expect-error TS2345 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
const PropertiesContext = createContext<PropertiesContextProps>(undefined);

export default PropertiesContext;
